const axios = require('./http/index')
export default {
    isBlank(obj) {
        return !obj || !/\S/.test(obj) || obj == undefined || obj === "null";
    },
    deviceType() {
        const ua = window['navigator']['userAgent'] || window['navigator']['vendor'] || window['opera']
        // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
        return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua) ? 'mb' : 'pc'
    },
    setStyle(obj) {
        return this.isBlank(obj) ? '' : obj;
    },
    // 扩充对象
    extendObj: function (a, b) {
        let result = a;
        for (let key in b) {
            result[key] = b[key];
        }
        return result;
    },
    addSesstion: function (key, value) {
        sessionStorage.setItem(key, value);
    },
    trackGA: function (eventCategory, eventAction, eventLabel) {
        try {
            gtag('event', eventAction, {
                // Event parameters
                'event_category': eventCategory,
                'event_label': eventLabel
                // ...
            });
        } catch (e) { }
    },

    //根据gameCode请求后台配置的图片位置信息
    getInfo(_url, _params) {
        return axios.default.jsonp(_url, { params: _params });
    }
}


// WEBPACK FOOTER //
// ./client/smsgz/util/index.js